
import * as React from 'react';
import * as PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import * as api from '../../../store/apiClient';
import { ApplicationState } from '../../../store';
import * as CustomerActions from '../../../store/pages/customer/actions';
import { clickHandler } from '../../../utils/util';
import ApiError from '../../global/apiError';

interface LocalProps {
    customerId: string;
    firstname: string;
    lastname: string;
    emailAddress: string;
    close: (reload: boolean) => void;
}

interface MappedState {
    isUpdatingStatus: boolean;
    statusChangeComplete: boolean;
    statusChangeError: api.ApiError | null;
}

interface Actions {
    deleteCustomer: (customerId: string) => void;
}

type ConfirmDeleteCustomerProps = LocalProps & MappedState & Actions;

class ConfirmDeleteCustomer extends React.Component<ConfirmDeleteCustomerProps, {}> {

    static contextTypes = {
        t: PropTypes.func
    }

    componentDidUpdate(prevProps: ConfirmDeleteCustomerProps) {
        if (this.props.statusChangeComplete && !prevProps.statusChangeComplete) {
            this.props.close(true);
        }
    }

    confirm = () => this.props.deleteCustomer(this.props.customerId);

    render() {
        const { firstname, lastname, emailAddress, close, isUpdatingStatus, statusChangeError } = this.props;
        const { t } = this.context;

        return (
            <div>
                <h3>{t('ConfirmDeleteCustomer:heading')}</h3>
                <div className='row form-group'>
                    <div className='col-md-12'>
                        <div className='alert alert-warning'>{t('ConfirmDeleteCustomer:message')}</div>
                    </div>
                </div>

                <div className='row mt-15'>
                    <div className='col-md-12'>
                        <label>{t('ConfirmDeleteCustomer:customerName')}</label>
                        <div>{firstname} {lastname}</div>
                    </div>
                </div>
                <div className='row mt-15'>
                    <div className='col-md-12'>
                        <label>{t('ConfirmDeleteCustomer:email')}</label>
                        <div>{emailAddress}</div>
                    </div>
                </div>

                {statusChangeError ? <ApiError error={statusChangeError} /> : null}

                <form className='data-form mt-15' onSubmit={e => e.preventDefault()} autoComplete='off'>
                    <div className='row form-group'>
                        <div className='col-md-12 btn-toolbar'>
                            <button className='btn btn-danger' disabled={isUpdatingStatus} onClick={e => clickHandler(e, this.confirm)}>{t('ConfirmDeleteCustomer:confirmDelete')}</button>
                            <button className='btn btn-basic' disabled={isUpdatingStatus} onClick={e => clickHandler(e, () => close(false))}>{t('Global:cancel')}</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    isUpdatingStatus: state.customers.isUpdatingStatus,
    statusChangeComplete: state.customers.statusChangeComplete,
    statusChangeError: state.customers.statusChangeError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deleteCustomer: bindActionCreators(CustomerActions.actionCreators.deleteCustomer, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteCustomer);
